import React from 'react';
import { Countdown } from './Countdown';
export function UrgencyBlock() {
  return <section aria-labelledby="urgencia-titulo" className="w-full border-y-4 border-gold bg-navy-deep py-12 text-white sm:py-14" data-id="element-273" data-mp="3iqdbhftriiv8">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-274" data-mp="3dxtvydbildns">
        <h2 id="urgencia-titulo" className="font-display text-2xl font-extrabold text-gold text-balance sm:text-3xl" data-id="element-275" data-mp="39ybe5qezpip6">
          ⏰ Este precio cierra pronto — y no vuelve
        </h2>

        <div className="mx-auto mt-6 max-w-xl space-y-3 text-base leading-relaxed text-celeste-light" data-id="element-276" data-mp="2zzcakm930d91">
          <p data-id="element-277" data-mp="2v1kav6273mua">
            El precio de lanzamiento es{' '}
            <strong className="font-extrabold text-white" data-id="element-278" data-mp="2qyxfiv6bfjsc">$19.990 ARS</strong>. Después
            sube <strong className="font-extrabold text-white" data-id="element-279" data-mp="2r1a61wq532h0">$8.000 ARS</strong> —
            permanente.
          </p>
          <p data-id="element-280" data-mp="p7u3q2kovz67">
            No es un truco de marketing: es la política de precios de lanzamiento que
            tenemos comprometida con quienes compran primero.
          </p>
        </div>

        <div className="mt-8" data-id="element-281" data-mp="19wqi8z6rvfp6">
          <Countdown data-id="element-282" data-mp="19x05if0fn8r6" />
        </div>

        <div className="mx-auto mt-8 max-w-md text-left" data-id="element-283" data-mp="19y1l8wse8jf8">
          <div className="h-3 w-full overflow-hidden rounded-full bg-white/15" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos al precio de lanzamiento tomados" data-id="element-284" data-mp="vxquruuzx6ul">
            <div className="h-full w-[68%] rounded-full bg-coral" data-id="element-285" data-mp="1snrgfl02j77o" />
          </div>
          <p className="mt-2 flex items-center gap-2 text-sm font-bold text-white" data-id="element-286" data-mp="1ew31l9yfq4n0">
            <span className="h-2.5 w-2.5 animate-pulse rounded-full bg-coral" aria-hidden="true" data-id="element-287" data-mp="1eu0bkpxa8bia" />
            68% de los cupos al precio de lanzamiento ya fueron tomados
          </p>
        </div>
      </div>
    </section>;
}